import styled from "@emotion/styled";
export const StyledParagraphWithDemoComponent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .paragraph-demo-wrapper {
    margin-top: 48px;
  }

  .paragraph-content-title {
    font-size: 1rem;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 24px;
  }

  .paragraph-content-description-wrapper {
    display: flex;

    .paragraph-content-icon {
      margin-right: 16px;
    }

    .paragraph-content-description {
      font-size: 0.875rem;
      line-height: 24px;
      flex-grow: 1;
    }
  }
`;
